import { Avatar, Box, Divider, Grid, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { selectRoutineInsUpd } from "../../../redux/routine/routineInsUpdSlice";
import { assertImagesUrl } from "../../../redux/common";

export function RoutineInsUpdReview() {
    const routineInsUpd = useSelector(selectRoutineInsUpd);

    return <>
        <Typography variant="h6" gutterBottom>
            Revisão
        </Typography>
        <Grid container spacing={3}>
            <Grid size={2}>
                <Typography component="div" variant="body1" color="darkgray" align="right">Nome</Typography>
            </Grid>
            <Grid size={10}>
                <Typography component="div" variant="body1" color="darkblue">{routineInsUpd.routine.name}</Typography>
            </Grid>
            <Grid size={2}>
                <Typography component="div" variant="body1" color="darkgray" align="right">Avatar</Typography>
            </Grid>
            <Grid size={10}>
                <Box sx={{ display: "flex", alignItems: "center", m: 1 }}>
                    <Avatar
                        src={assertImagesUrl(routineInsUpd.routine.url)}
                        alt={routineInsUpd.routine.name}
                        sx={{ width: 60, height: 60, border: "1px solid #ccc" }}
                    />
                </Box>
            </Grid>
        </Grid>
        <Divider flexItem />
    </>;
}